import React, {useState, useEffect} from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { useTime } from '../contexts/TimeContext'


export default function BodyCard(props) {
  const { place_id, place_subname, area_id, area_name, hiddenAreaflg} = props;
  const [card, setCard] = useState([])
  const [image, setImage] = useState([])
  const [lastFetched, setLastFetched] = useState(null)
  const [snowRatio, setSnowRatio] = useState('-')
  const [snowplowRatio, setSnowplowRatio] = useState('-')

  const { displayTime } = useTime();

  useEffect(() => {
    axios.get(`/api/prediction/snow_ratio/${place_id}?only_latest=1`)
      .then(res => {
        if (res.data.length > 0) {
          // 小数点第二位で四捨五入
          const ratio = Math.round(res.data[0].snow_ratio * 1000) / 10
          setSnowRatio(`${ratio} %`)
        }
      })
  }, [place_id])

    useEffect(() => {
        setTimeout(() => {
            axios.get(`/api/prediction/snowplows/${area_id}`)
                .then(res => {
                    if (res.data === -1) {
                        setSnowplowRatio('-')
                    } else {
                        let ratio = Math.round(res.data * 1000) / 10;
                        setSnowplowRatio(`${ratio} %`)
                    }
                })
        }, lastFetched === null ? 0 : 3600000)
    });


  useEffect(() => {
      const hour = displayTime.getHours().toString().padStart(2, '0');
      const minute = displayTime.getMinutes().toString().padStart(2, '0');
      const second = displayTime.getSeconds().toString().padStart(2, '0');
      const hhmmss = `${hour}${minute}${second}`
      axios.get(`/api/image/realtime/${place_subname}/${hhmmss}`, {responseType: 'blob',})
        .then(res => {
          if (res.data != null) {
            setImage([URL.createObjectURL(res.data)])
          }
          setLastFetched(Date())
        })
        .catch(() => {
          setLastFetched(Date())
        })
  }, [displayTime])

  useEffect(() => {
    setTimeout(() => {
      axios.get(`/api/weathernews/${place_id}`)
        .then(res => {
          setCard(res.data)
        })
    }, lastFetched === null ? 0 : 3600000)
  })

  const flagStyle = {
    visibility: hiddenAreaflg ? 'hidden' : '',
  };


  return (
    <div class="bl_item">
      <div className={`bl_area_box bl_area${area_id}`}>
        <div class="bl_areaBox_top" style={flagStyle}>
          <div class="bl_top_left">
            <div class="el_areaName">
              <p>{area_name}</p>
            </div>
            <div class="el_areaLogo">
              <img src="/img/areaLogo.png" alt="" />
            </div>
            <div class="el_areaRatio">
              <p>{snowplowRatio}</p>
            </div>
          </div>
          <div class="bl_top_right">
          </div>
        </div>
        <div class="bl_areaBox_under">
        </div>
      </div>
      <div class="bl_itemTitle">
        <div class="el_itemTitle_logo">
          <img src="/img/camera_logo.png" alt="" />
        </div>
        <div class="el_itemTitle_name">
          <h3>{place_subname}</h3>
        </div>
      </div>
      <div class="el_itemVideo">
        <img src={image} alt="" />
      </div>
      <div class="bl_itemInfo">
        <div class="bl_itemWeather">
          <div class="el_itemWeather_logo">
            <div class="el_logoInner">
              <div class="bl_itemWeather_inner">
                <div class="el_logo">
                  <img src="/img/weater_logo.png" alt="" />
                </div>
              </div>
              <div class="el_weatherText">
                <p>{card.wx_name}</p>
              </div>
            </div>
            <div class="bl_snowCover">
              <div class="modalOpen bl_snowCover_inner">
                <div class="el_snowCover_logo">
                  <img src="/img/snow_cover.png" alt="" />
                  <div class="description">積雪割合</div>
                </div>
                <div class="el_snowCover_txt">
                  <p>{snowRatio}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="bl_itemDetail">
          <div class="bl_itemTemp">
            <div class="el_tempInner">
              <div class="el_itemTemp_logo">
                <div class="el_logo">
                  <img src="/img/temp_logo.png" alt="" />
                </div>
                <p>{card.temp}℃</p>
              </div>
              <div class="el_itemBtn">
                <Link to={`/place/${place_id}`}>
                  <button>詳 細</button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
